var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-container"},[_c('h1',{staticClass:"faq-container__title strong"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._l((_vm.faqs),function(faq){return _c('item',{key:faq.id,staticClass:"faq-container__items",attrs:{"item":faq}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }